import * as React from 'react';
import { observer } from 'mobx-react';
import { Body1 } from 'elc-typography';
import { classes } from '../../utils/Classes';
import { IProductBenefitTypes } from '../../interfaces/IProdcat';

export interface IProductBenefitType {
    productId: string;
    skuId: string | number;
    benefitTypes?: IProductBenefitTypes;
}

const benefitTypeClassName = classes('product-benefit-type');

export const ProductBenefitType = observer((props: IProductBenefitType) => {
    const { productId, skuId, benefitTypes } = props;

    const benefitType = benefitTypes && (benefitTypes[skuId] || benefitTypes[productId]);

    return <>{benefitType && <Body1 className={benefitTypeClassName}>{benefitType}</Body1>}</>;
});
